import React from 'react';

import Text from '~/components/core/TextComponents/Text';

interface CardMetaProps {
  /** What became of the thing, or which message a question raised in reply answers. */
  status: React.ReactNode;
  /** How sure Clive was of the thing, where it sent a score. */
  confidence?: React.ReactNode;
}

/**
 * The line over a card's title: its state, or the message a question raised in reply answers, and its
 * confidence, divided by a rule.
 *
 * The confidence sits in its own cell, and that cell is hidden when empty — a confidence chip with
 * no score renders nothing — so no rule is left dangling beside a missing chip.
 */
const CardMeta: React.FC<CardMetaProps> = ({ status, confidence }) => (
  // Capped at the line's width, and each cell may shrink, so a long chip ellipsises rather than
  // overflowing a narrow card.
  <div className="flex min-w-0 max-w-full items-center">
    <div className="flex min-w-0 pr-12">{status}</div>
    {/* The rule is this cell's left border alone: the repo runs without Tailwind's preflight, so a
        `divide-solid` would also draw the browser's default medium border on the other three sides. */}
    <div className="flex min-w-0 border-0 border-l border-solid border-slate-300 pl-12 empty:hidden">{confidence}</div>
  </div>
);

/**
 * When Clive raised the thing, over the card rather than inside it, so the chips have the card's
 * whole width and the date is never squeezed beside them.
 */
export const CardTime: React.FC<{ time: string | null }> = ({ time }) =>
  time ? (
    <Text
      variant={Text.VARIANTS.XS}
      colorVariant={Text.COLOR_VARIANTS.SECONDARY}
      className="whitespace-nowrap text-right"
    >
      {time}
    </Text>
  ) : null;

export default CardMeta;
